module.exports = __webpack_public_path__ + "squares-4203880d5657219354e3546598927e6e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/lesson/squares.svg
// module id = 186
// module chunks = 0 1 2